import React, { Component } from "react";
import MediaView from "./MediaView";

class Collection extends Component{
    state={
        ambassador: null,
        products: []
    }
    render(){
        const {asset} = window.TVSite.channelVideosData;
        const {products} = this.props;

        return <div>
            <MediaView content={asset} products={products} />
        </div>
    }
}

Collection.defaultProps = {
    products: []
}
export default Collection;
